import * as React from 'react';
import { BaSeSmall1, BaSeTheme } from '@base/react';
import { FlexedJC } from '../fluxo/relatorio-fluxo-consolidado-styled';
import { WrapperGrid } from '../relatorios-card-styled';
import { ShowMoney } from '../../../pages/new-relatorios/relatorios-mei';

export const RelatorioMensalMei = ({ dados }) => {
  const { cinzaSebrae20 } = BaSeTheme.colors.institucionais;
  return (
    <>
      {dados && (
        <>
          {dados?.blocoLancamentos?.length &&
            dados?.blocoLancamentos?.map((item, index) => (
              <React.Fragment key={index}>
                <FlexedJC>
                  <WrapperGrid>
                    <BaSeSmall1 isBold color={cinzaSebrae20}>
                      {item?.tipoReceita ?? ''}
                    </BaSeSmall1>
                  </WrapperGrid>
                </FlexedJC>
                {item?.lancamentos?.length &&
                  item?.lancamentos?.map((lancamento, i) => (
                    <React.Fragment key={`${index}-${i}`}>
                      <FlexedJC>
                        <WrapperGrid>
                          <BaSeSmall1 color={cinzaSebrae20}>
                            {lancamento?.descricao ?? ''}
                          </BaSeSmall1>
                        </WrapperGrid>
                        <ShowMoney value={lancamento?.total} />
                      </FlexedJC>
                    </React.Fragment>
                  ))}
              </React.Fragment>
            ))}
          <FlexedJC last>
            <BaSeSmall1 last isBold color={cinzaSebrae20}>
              {dados?.totalDetalhe?.descricao ?? ''}
            </BaSeSmall1>
            <ShowMoney value={dados?.totalDetalhe?.total} />
          </FlexedJC>
        </>
      )}
    </>
  );
};
